export default class TeachrHours {
    totalCourses: string;
    totalHours: string;
    constructor(totalCourses: string, totalHours: string) {
        this.totalCourses = totalCourses
        this.totalHours = totalHours
    }
}
